import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "bar"]

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.barTarget.classList.toggle("translate-y-full", entry.isIntersecting)
        this.barTarget.classList.toggle("translate-y-0", !entry.isIntersecting)
      },
      { threshold: 0 }
    )

    this.observer.observe(this.cardTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
